module.exports = __webpack_public_path__ + "img/review-icon.9166e68e.svg";